export { default } from './ViewWalletInfoLayout';
